import apiClient from "../config/apiClient";

export const sendRequest = async (id,requestType, items,note) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.post(`/public/portal?url=requests/save-request?patient_id=${id}`,
       {requestType, ...note, items, "overTheCounter":true}, 
       {
        headers: {
        Authorization: "Bearer " + token,
      },
    });
};